var scrollTop = 0;
export default {
    getScrollTop() {
        return scrollTop;
    },
    setScrollTop(num) {
        scrollTop = num;
    },
}
